<div class="inner-content">
    <p class="list-header">
        Dane adresata
    </p>

    <form [formGroup]="form">
        <div *ngFor="let group of addressesFormArray.controls; let last = last; let index = index; let first = first;"
             [formGroup]="group"
        >
            <div class="address-row">
                <ns-send-message-address-select [group]="group">
                </ns-send-message-address-select>
            </div>

            <cmn-errors [control]="group['controls']['address']"></cmn-errors>
        </div>

        <p class="list-header">
            Podgląd wiadomości:
        </p>

        <div class="message-preview">
            <h2>Dzień dobry</h2>
            <p class="desc">Przesyłam pakiet dokumentów Wagas do pobrania.<p>

            <div class="custom-text-container">
                <button *ngIf="!isCustomMessageEnabled"
                  type="button"
                  kendoButton
                  [primary]="true"
                  class="big"
                  (click)="addCustomText()"
                >
                    DODAJ WŁASNĄ TREŚĆ
                </button>

                <textarea *ngIf="isCustomMessageEnabled"
                  formControlName="customMessage"
                  kendoTextArea
                ></textarea>
                <cmn-errors [control]="form.get('customMessage')"></cmn-errors>
            </div>

            <p class="desc">Kliknij, aby pobrać:</p>

            <div class="message-content">
                <div class="make-box" *ngFor="let group of documents?.data;">
                    <div class="make-box-inner" *ngIf="selectedMakes[group.id] && hasDocumentsForMake(group)">

                        <div class="title">
                            {{ group.name }}
                        </div>
                        <div class="documents">
                            <ng-container *ngFor="let doc of group?.documents;">

                                <div class="item" *ngIf="selectedDocuments[doc.id]">
                                    <div class="doc-name">
                                        {{ doc?.name }} ({{ doc?.file?.extension | uppercase }})
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>


                <div class="make-box" *ngIf="hasSelectedMyDocuments">
                    <div class="make-box-inner">
                        <div class="title">
                            DODATKOWE DOKUMENTY
                        </div>
                        <div class="documents">
                            <ng-container *ngFor="let doc of myDocuments?.data;">
                                <div class="item" *ngIf="selectedDocuments['MYDOC_' + doc.id]">
                                    <div class="doc-name">
                                        {{ doc?.name }} ({{ doc?.file?.extension | uppercase }})
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>


                <div class="signature">

                    <p>Pozdrawiam,</p>
                    <p>
                        <b>{{ userName }}</b>
                    </p>
                    <p class="signature__info">{{ email }}</p>
                    <p class="signature__info"> {{ phone }}</p>
                </div>
            </div>


        </div>
    </form>
</div>

<ns-floating-footer
    (backClick)="onGoBack()"
    (mainClick)="onNext()"
    mainButtonText="Wyślij"
></ns-floating-footer>
